﻿export class SortDescription {
    constructor(public columnName: string, public ascending?: boolean) {}
}